export const CLEARREDUX = () => {
    return {
        type: "CLEAR_REDUX",
    };
};
export function ClearRedux() {
    return (dispatch) => {
        dispatch(CLEARREDUX());
    };
}